import { Anchor } from '@radix-ui/react-popover'

export const PopoverAnchor = Anchor
